import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column items-center text-center" }
const _hoisted_2 = { class: "relative-position q-mb-md" }
const _hoisted_3 = { class: "text-h5 text-white q-mb-xs" }
const _hoisted_4 = { class: "text-subtitle2 text-white opacity-80 q-mb-lg" }
const _hoisted_5 = {
  key: 0,
  class: "q-mt-md q-mb-lg"
}
const _hoisted_6 = { class: "text-h6 text-white" }
const _hoisted_7 = { class: "text-subtitle2 text-white opacity-90" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderPending',
  props: {
    startDate: {},
    duration: {}
  },
  setup(__props: any) {

const props = __props

// 🌍 Sprache anhand der URL bestimmen
const path = window.location.pathname
const lang = path.startsWith('/en/') ? 'en' : 'de'

// Dynamische Fehlermeldung
const message1 = computed(() =>
  lang === 'de'
    ? 'Zahlung wird verarbeitet'
    : 'Payment is processed'
)

const message2 = computed(() =>
  lang === 'de'
    ? 'Einen Moment Geduld…'
    : 'Just a moments patience...'
)

const message3 = computed(() =>
  lang === 'de'
    ? 'Termin wird erstellt und'
    : 'Appointment will be created and'
)

const message4 = computed(() =>
  lang === 'de'
    ? 'die Bestätigung wird gleich gesendet.'
    : 'confirmation will be sent right away.'
)

const formattedDate = computed(() => {
  if (!props.startDate) return ''
  return new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(props.startDate)
})

const timeRange = computed(() => {
  if (!props.startDate || !props.duration) return ''
  const start = props.startDate
  const end = new Date(start.getTime() + props.duration * 60000)
  const fmt = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' })
  return `${fmt.format(start)} – ${fmt.format(end)} Uhr`
})

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "loading-card q-pa-xl q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_spinner, {
            color: "white",
            size: "80px"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pulse" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(message1.value), 1),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(message2.value), 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(message3.value), 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(message4.value), 1)
        ]),
        _createVNode(_component_q_separator, {
          dark: "",
          spaced: ""
        }),
        (__props.startDate && __props.duration)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(formattedDate.value), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(timeRange.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})